var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',{scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('div',{staticClass:"desktop"},[_c(_vm.currentPlatformComponent,{key:_vm.d_id,tag:"component",attrs:{"id":_vm.d_id}})],1)]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }